export enum FiltersSidebarSizeType {
    DESKTOP,
    EXTRALARGE,
    LARGE,
    MEDIUM,
    SMALL,
}
